import { useMutation, useQueryClient } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';
import { message } from 'antd';

const useSaveTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: any) => {
      // If id exists, it's an update, otherwise create
      // Note: product is automatically set by the controller based on mode
      if (payload.id) {
        const response = await instance.put(`/nexa/diagnostic-templates/${payload.id}`, {
          name: payload.name,
          deep: payload.deep,
          extra_instructions: payload.extra_instructions,
        });
        return response.data;
      } else {
        const response = await instance.post(`/nexa/diagnostic-templates`, {
          type: payload.type,
          name: payload.name,
          deep: payload.deep,
          extra_instructions: payload.extra_instructions,
        });
        return response.data;
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['diagnostic-templates']);
        queryClient.invalidateQueries(['diagnostic-modes']);
        message.success('Template saved successfully');
      },
      onError: (error: any) => {
        const errorMessage = error.response?.data?.detail || 'Failed to save template';
        message.error(errorMessage);
      },
    },
  );
};

export default useSaveTemplate;
